import React from 'react';
import StatCard from '../../components/ui/StatCard.jsx';
import Card from '../../components/ui/Card.jsx';
import { Link } from '../../router.jsx';
import { useApi } from '../../hooks/useApi.js';

export default function StudentDashboard() {
  const { data: requestsData } = useApi('/api/requests');
  const { data: surveyData } = useApi('/api/surveys/active');

  const requests = requestsData?.items || [];
  const activeRequests = requests.filter((req) => req.status === 1).length;
  const activeSurvey = surveyData?.active;

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>Student Dashboard</h1>
          <p className="subtle">Quick access to your academic workflow.</p>
        </div>
        <Link to="/student/requests/new" className="btn btn-primary">New Request</Link>
      </div>

      <div className="grid three">
        <StatCard label="Active Requests" value={String(activeRequests)} trend="Awaiting advisor review" />
        <StatCard label="Plan Updates" value="—" trend="See Study Plan" />
        <StatCard label="Survey Status" value={activeSurvey ? 'Open' : 'Closed'} trend={activeSurvey ? activeSurvey.semester || 'Active' : 'No active survey'} />
      </div>

      <Card title="Advisor Notes">
        <p className="subtle">No new notes. Keep your profile updated and reach out if you need support.</p>
      </Card>
    </div>
  );
}
